import { Card, CardActionArea, CardContent, Typography } from '@mui/material';

import { AddCircle } from '@mui/icons-material';

interface CreateActivationCardProps {
  onCreate: () => void;
}

const CreateActivationCard: React.FC<CreateActivationCardProps> = ({
  onCreate,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '300px',
        height: '310px',
      }}
      onClick={onCreate}
    >
      <CardActionArea onClick={onCreate} sx={{ height: '100%' }}>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <AddCircle color="primary" sx={{ fontSize: 50 }} />
          <Typography variant="h6" mt={1} sx={{ textAlign: 'center' }}>
            Create New Activation
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CreateActivationCard;
